export const CONSOLE_RUN_CODE = '@@console/RUN_CODE';
export const CONSOLE_RUN_CODE_SUCCESS = '@@console/RUN_CODE_SUCCESS';
export const CONSOLE_RUN_CODE_FAILURE = '@@console/RUN_CODE_FAILURE';

export const CONSOLE_SET_INPUT = '@@console/SET_INPUT';
export const CONSOLE_CLEAR_ALL = '@@console/CLEAR_ALL';
